////AddController.js
//import React, { useState, useEffect } from 'react';
//import "../../Assets/Styles/Form.css";
//import Axios from 'axios';
//import * as FaIcons from "react-icons/fa";
//import { hasJWTToken } from "../Account/RouteGuard";
//import Select from 'react-select';
//import Form from 'react-bootstrap/Form';
//import AxiosInstance from '../Axios/AxiosInstance';
//export const PlantController = () => {
//    const _userID = sessionStorage.getItem("user_id");
//    const role_id = sessionStorage.getItem("role_id");
//    const [plantOption, setPlantOption] = useState([]);
//    let _token = sessionStorage.getItem("token");
//    if (_token) _token = "Token exists";
//    let [formData, setFormData] = useState({
//        plant_id: null,
//        controller_id: null,
//        controller_name: '',
//        user_id: _userID,
//        jwt_token: _token,
//        controller_mode: 'Insert',
//        message: '',
//    });
//    const [errors, setErrors] = useState({});
//    const handleChange = (e) => {
//        const { name, value } = e.target;
//        setFormData({
//            ...formData,
//            [name]: value,
//        });
//    };
//    const handleSubmit = (e) => {
//        e.preventDefault();
//        var newErrors = validateForm(formData);
//        setErrors(newErrors);
//        if (Object.keys(newErrors).length === 0) {
//            formData.controller_mode = "Insert";
//            formData.user_id = 1;
//            try {
//                let objControllerData = AxiosInstance.post("/PlantControllers", formData)
//                //'Controller submitted successfully!'
//                // formData.plant_id = null;
//                formData.controller_name = '';
//                setFormData(formData);
//                formData.message = "Added new controller successfully!";
//                console.log('Form submitted successfully!');
//            }
//            catch (error) {
//                console.log(error)
//            }
//        } else {
//            formData.message = 'Controller submission failed due to validation errors.'
//            console.log('Form submission failed due to validation errors.');
//        }
//    };
//    const validateForm = (data) => {
//        const errors = {};
//        if (!data.plant_id.trim()) {
//            errors.plant_id = 'Plant ID is required';
//        } else if (data.plant_id.length > 10) {
//            errors.plant_id = 'Plant ID should not be less than or more than 10 digits';
//        }
//        if (!data.controller_name.trim()) {
//            errors.controller_name = 'Robot name is required';
//        } else if (data.controller_name.length > 50) {
//            errors.controller_name = 'Robot name should not be less than or more than 50 characters';
//        }
//        return errors;
//    };
//    const handleSelectChange = (e) => {
//        formData.plant_id = e.target.value;
//    };
//    useEffect(() => {
//        fetchPlantList();
//    }, [])
//    useEffect(() => {
//        console.log(plantOption)
//    }, [plantOption])
//    const fetchPlantList = async () => {
//        var userID = sessionStorage.getItem("user_id");
//        let response = await Axios("/DropDownList/GetPlantList?paramid=1&=uid=" + userID + "&pn=PlantList&dn=PlantList");
//        setPlantOption(response.data);
//    };
//    return (
//         <>
//         {hasJWTToken() && (role_id === 1) ? (
//        <div className="container-ul">
//            <div className="form-container">
//            <h2 className="form-title"><FaIcons.FaRegEdit /> Add New Controller</h2>
//            <span className="form-message">
//                {formData.message}
//            </span>
//            <form onSubmit={handleSubmit}>
//                <div>
//                    <Form.Select name="plant_id" onChange={handleSelectChange}>
//                        {plantOption.map(opt => (
//                            <option value={opt.plant_id}>{opt.plant_name}</option>
//                        ))}
//                    </Form.Select>
//                </div>
//                {/*<div>*/}
//                {/*    <input*/}
//                {/*        className="form-input"*/}
//                {/*        type="number"*/}
//                {/*        maxLength="10"*/}
//                {/*        name="plant_id"*/}
//                {/*        value={formData.plant_id}*/}
//                {/*        onChange={handleChange}*/}
//                {/*        placeholder="Enter plant ID (Max limit 10 digits)"*/}
//                {/*    />*/}
//                {/*    {errors.plant_id && (*/}
//                {/*        <span className="error-message">*/}
//                {/*            {errors.plant_id}*/}
//                {/*        </span>*/}
//                {/*    )}*/}
//                {/*</div>*/}
//                <div>
//                    <input
//                        className="form-input"
//                        type="text"
//                        name="controller_name"
//                        maxLength="50"
//                        value={formData.controller_name}
//                        onChange={handleChange}
//                        placeholder="Enter controller name (Max limit 50 chars)"
//                    />
//                    {errors.controller_name && (
//                        <span className="error-message">
//                            {errors.controller_name}
//                        </span>
//                    )}
//                </div>
//                <div class="row">
//                    <div class="col-8"><button className="submit-button" type="submit">Submit</button></div>
//                    <div class="col-4"><a className="btndelete" href="#/SearchController">Search Controller</a></div>
//                </div>
//            </form>
//            </div>
//                </div>
//            ) :
//                (
//                    window.location.href = "#/Login"

//                )
//            }
//        </>
//    );
//}
//export default PlantController;







// PlantController.js
import React, { useState, useEffect } from 'react';
import "../../Assets/Styles/Form.css";
import Axios from 'axios';
import * as FaIcons from "react-icons/fa";
import { hasJWTToken } from "../Account/RouteGuard";
import Form from 'react-bootstrap/Form';
import AxiosInstance from '../Axios/AxiosInstance';

export const PlantController = () => {

    // Read session values safely (defaulting where required)
    const userID = sessionStorage.getItem("user_id");
    const role_id = sessionStorage.getItem("role_id");

    // Dropdown options
    const [plantOption, setPlantOption] = useState([]);

    // Controlled form state (never mutate directly)
    const [formData, setFormData] = useState({
        plant_id: "",
        controller_id: null,
        controller_name: "",
        user_id: userID,
        jwt_token: sessionStorage.getItem("token") ? "Token exists" : "",
        controller_mode: "Insert",
        message: "",
    });

    // Validation errors
    const [errors, setErrors] = useState({});

    // Generic input change handler
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    // Select dropdown change handler
    const handleSelectChange = (e) => {
        const value = e.target.value;

        setFormData(prev => ({
            ...prev,
            plant_id: value,
        }));
    };

    // Validate form input
    const validateForm = (data) => {
        const err = {};

        // Plant ID validation
        if (!data.plant_id) {
            err.plant_id = "Plant ID is required";
        } else if (data.plant_id.toString().length !== 10) {
            err.plant_id = "Plant ID must be exactly 10 digits";
        }

        // Controller name validation
        if (!data.controller_name.trim()) {
            err.controller_name = "Robot name is required";
        } else if (data.controller_name.length > 50) {
            err.controller_name = "Robot name cannot exceed 50 characters";
        }

        return err;
    };

    // Submit form
    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = validateForm(formData);
        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            setFormData(prev => ({
                ...prev,
                message: "Validation failed. Please check the fields."
            }));
            return;
        }

        try {
            // ALWAYS await API calls
            await AxiosInstance.post("/PlantControllers", {
                ...formData,
                controller_mode: "Insert",
                user_id: userID,
            });

            // Clear form AFTER successful insert
            setFormData(prev => ({
                ...prev,
                controller_name: "",
                message: "Added new controller successfully!",
            }));

        } catch (err) {
            console.error(err);
            setFormData(prev => ({
                ...prev,
                message: "Something went wrong while saving."
            }));
        }
    };

    // Fetch dropdown list
    const fetchPlantList = async () => {
        try {
            const response = await Axios(`/DropDownList/GetPlantList?paramid=1&uid=${userID}&pn=PlantList&dn=PlantList`);
            setPlantOption(response.data || []);
        } catch (err) {
            console.error("Failed to load plant list", err);
        }
    };

    // Load plants on component mount
    useEffect(() => {
        fetchPlantList();
    }, []);

    // Simple access protection (role check string-safe)
    if (!hasJWTToken()) {
        window.location.href = "#/Login";
        return null;
    }

    return (
        <div className="container-ul">
            <div className="form-container">

                <h2 className="form-title">
                    <FaIcons.FaRegEdit /> Add New Controller
                </h2>

                <span className="form-message">{formData.message}</span>

                <form onSubmit={handleSubmit}>

                    {/* Plant dropdown */}
                    <Form.Select name="plant_id" onChange={handleSelectChange} value={formData.plant_id}>
                        <option value="">-- Select Plant --</option>
                        {plantOption.map(opt => (
                            <option key={opt.plant_id} value={opt.plant_id}>
                                {opt.plant_name}
                            </option>
                        ))}
                    </Form.Select>
                    {errors.plant_id && <span className="error-message">{errors.plant_id}</span>}

                    {/* Controller Name */}
                    <input
                        className="form-input"
                        type="text"
                        name="controller_name"
                        maxLength="50"
                        value={formData.controller_name}
                        onChange={handleChange}
                        placeholder="Enter controller name"
                    />
                    {errors.controller_name && (
                        <span className="error-message">{errors.controller_name}</span>
                    )}

                    <div className="row">
                        <div className="col-8">
                            <button className="submit-button" type="submit">Submit</button>
                        </div>
                        <div className="col-4">
                            <a className="btndelete" href="#/search-controller">Search Controller</a>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    );
};

export default PlantController;
